module.exports = __webpack_public_path__ + "static/media/logo-text.3c0f0085.png";